import { X } from 'lucide-react';

import { Link } from '@/components/link';
import { SavedItemType } from '@/lib/models/saved-item/types';
import { tv } from '@/utils/styles';
import { trackUser } from '@/utils/tracking';

export interface SavedItemProps {
  icon: React.ReactElement;
  label: string;
  type?: SavedItemType;
  href: string;
  onDelete: () => void;
  shouldHideDelete?: boolean;
  variant?: 'light' | 'dark';
}

const SavedItem = ({
  onDelete,
  icon,
  label,
  type,
  href,
  shouldHideDelete = true,
  variant = 'dark',
}: SavedItemProps) => {
  const { base, button, buttonLabel, deleteButton } = styles({ variant, shouldHideDelete });

  const handleClick = () => {
    trackUser.event(`Clicked saved item`, { label, type, from: 'Navigation' });
  };

  return (
    <li className={base()}>
      <Link href={href} className={button()} type="button" title={label} onClick={handleClick}>
        {icon}
        <span className={buttonLabel()}>{label}</span>
      </Link>
      <button className={deleteButton()} type="button" onClick={onDelete} title="Delete" aria-label="delete">
        <X size={14} />
      </button>
    </li>
  );
};

const styles = tv({
  slots: {
    base: 'group flex items-center justify-between rounded px-1',
    button: 'flex-1 overflow-hidden overflow-ellipsis whitespace-nowrap px-1 py-2 text-sm leading-none md:py-1.5',
    buttonLabel: 'ml-1',
    deleteButton: 'hidden pr-0.5 leading-[0] text-lightBlue-500 group-hover:block',
  },
  variants: {
    shouldHideDelete: {
      false: {
        deleteButton: 'block',
      },
    },
    variant: {
      light: {
        base: '-mx-1.5 hover:bg-grey-100',
        deleteButton: 'hover:text-grey-900',
      },
      dark: {
        base: 'hover:bg-blue-500',
        deleteButton: 'hover:text-white',
      },
    },
  },
});

export { SavedItem };
